import { FlowManager } from '../../flow-management/FlowManager';
import { shouldAddOptionalPhoneNumber } from '../../step-code-verification/shouldRemoveOptionalPhoneNumber';
import { Step } from '../../views/Step';
export const BranchOptionalPhoneNumber = {
  name: 'BranchOptionalPhoneNumber',
  stateCheck: shouldAddOptionalPhoneNumber,
  rebuildFlow: FlowManager.replaceStep(Step.CompanyDomain, Step.CompanyDomain, Step.OptionalPhoneNumber),
  processed: false,
  processedOnStep: null,
  afterData: null,
  afterStep: null
};